// extracted by mini-css-extract-plugin
module.exports = {"draganddrop-placeholder":"DragAndDrop_draganddrop-placeholder__znQej"};